import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import { SlideOver } from '../ui/SlideOver'
import { GtagEvents, gtmTrackButtonPress } from '../../utils/gtmUtils'
import { cardAddProxy } from '../CardAddSlideOver/cardAddProxy'
import { ConvergeLightboxSlideContents } from './ConvergeLightboxSlideContents'

const cancelFunction = (): void => {
  cardAddProxy.displayConvergeSlideOver = false
  gtmTrackButtonPress(GtagEvents.CARD_MODAL_CANCEL)
  //resetVirtualTerminalCardAddProxy()
}

export function ConvergeLightboxSlideover (): ReactElement {
  const { displayConvergeSlideOver, allowSubmitCAP } = useSnapshot(cardAddProxy)
  //useEffect(() => resetVirtualTerminalCardAddProxy, [])
  return (
    <SlideOver cancelText="Back" submitText="Next" canSubmit={allowSubmitCAP} isOpen={displayConvergeSlideOver} title="Add Credit Card" cancelFunction={cancelFunction}>
      <ConvergeLightboxSlideContents />
    </SlideOver>
  )
}
